import { useState } from 'react';
import type { ShopStatusDTO } from '@nine80/shared';
import { api } from '../lib/api';
import { usePolling } from './usePolling';

/** Server-authoritative open/closed + walk-in acceptance state, refreshed periodically.
 * Never derive this from the browser's clock — see docs/ARCHITECTURE.md. */
export function useShopStatus(intervalMs = 30000) {
  const [status, setStatus] = useState<ShopStatusDTO | null>(null);
  const [loading, setLoading] = useState(true);

  usePolling(async () => {
    try {
      const res = await api.shopStatus();
      setStatus(res);
    } finally {
      setLoading(false);
    }
  }, intervalMs);

  return { status, loading };
}
